// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__-aiLo","loader":"Loader_loader__3WOus"};